var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.breadItems),function(item,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":item.path}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }